import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

import DialogWithEnterAction from '../components/DialogWithEnterAction';
import Desc from '../FormWidgets/Description';

export const GROW_CYCLE_USER_DAY_MIN = 1;
export const GROW_CYCLE_USER_DAY_MAX = 2190;

export function isValidGrowCycleUserDay(value) {
  const day = Number(value);
  return (
    Number.isInteger(day) &&
    day >= GROW_CYCLE_USER_DAY_MIN &&
    day <= GROW_CYCLE_USER_DAY_MAX
  );
}

export default function GrowCycleDayDialog({ open, currentDay, onClose, onSet, disabled = false }) {
  const { t } = useTranslation();
  const [input, setInput] = React.useState('1');
  const valid = isValidGrowCycleUserDay(input);

  React.useEffect(() => {
    if (!open) return;
    setInput(isValidGrowCycleUserDay(currentDay) ? String(Number(currentDay)) : '1');
  }, [currentDay, open]);

  const apply = () => {
    if (!valid || disabled) return;
    onSet(Number(input));
    onClose();
  };

  return (
    <DialogWithEnterAction
      open={open}
      onClose={onClose}
      onEnterAction={apply}
      enterActionDisabled={!valid || disabled}
      aria-labelledby="set-grow-cycle-day-title"
    >
      <DialogTitle id="set-grow-cycle-day-title">
        <Desc id="set_current_day_in_grow_cycle" />
      </DialogTitle>
      <DialogContent>
        <TextField
          id="grow_cycle_day"
          autoFocus
          fullWidth
          type="number"
          disabled={disabled}
          label={t('day')}
          value={input}
          onChange={(event) => setInput(event.target.value)}
          inputProps={{
            min: GROW_CYCLE_USER_DAY_MIN,
            max: GROW_CYCLE_USER_DAY_MAX,
            step: 1
          }}
          error={input !== '' && !valid}
          helperText={`${GROW_CYCLE_USER_DAY_MIN} - ${GROW_CYCLE_USER_DAY_MAX}`}
        />
      </DialogContent>
      <DialogActions>
        <Button color="primary" disabled={disabled} onClick={() => {
          if (disabled) return;
          onSet(1);
          onClose();
        }} style={{ marginRight: 'auto' }}>
          {t('schedule_new_cycle')}
        </Button>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button color="primary" variant="contained" onClick={apply} disabled={!valid || disabled}>
          {t('save')}
        </Button>
      </DialogActions>
    </DialogWithEnterAction>
  );
}
